module.exports = __webpack_public_path__ + "static/media/Newspaper Kid.09e43dc6.jpg";